<template>
	<el-dialog
		:visible.sync="visible"
		:title="!dataForm.id ? $t('add') + '进项发票' :'发票详情'"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
	>
		<el-form :model="dataForm" :rules="dataRule" ref="dataForm" :label-width="$i18n.locale === 'en-US' ? '120px' : '100px'">
			<el-row>
				<el-col :span="12">
					<el-form-item label="发票代码：" prop="code"><el-input :disabled="dataForm.id > 0?true:false" style="width: 95%;" v-model="dataForm.code" placeholder="发票代码"></el-input></el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="发票号码：" prop="number"><el-input :disabled="dataForm.id > 0?true:false" style="width: 95%;" v-model="dataForm.number" placeholder="发票号码"></el-input></el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="发票金额：" prop="amount"><el-input :disabled="dataForm.id > 0?true:false" style="width: 95%;" v-model="dataForm.amount" placeholder="发票金额"></el-input></el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="发票税额：" prop="tax"><el-input :disabled="dataForm.id > 0?true:false" style="width: 95%;" v-model="dataForm.tax" placeholder="发票税额"></el-input></el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="价税合计：" prop="total"><el-input :disabled="dataForm.id > 0?true:false" style="width: 95%;" v-model="dataForm.total" placeholder="价税合计"></el-input></el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="开票时间：" prop="billingDate">
						<el-date-picker style="width: 95%;" :disabled="dataForm.id > 0?true:false"
							v-model="dataForm.billingDate"
							start-placeholder="开票时间"
							align="right"
							type="datetime"
							format="yyyy-MM-dd HH:mm:ss"
							value-format="yyyy-MM-dd HH:mm:ss"
						></el-date-picker>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="备注：" prop="remark">
						<el-input style="width: 95%;" rows="4" :disabled="dataForm.id > 0?true:false" type="textarea" v-model="dataForm.remark" placeholder="备注" :autosize="{ minRows: 4, maxRows: 10 }"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item label="上传票据：" prop="attachment">
						<el-upload :disabled="dataForm.id > 0?true:false"
						  class="upload-demo"
						  :action="url"
						  :on-remove="handleRemove"
						  multiple
						  :limit="20"
							:on-preview="handlePreview"
						  :before-upload="beforeUploadHandle"
						  :on-success="successHandle"
						  :on-error="backerror"
						  :file-list="fileList">
						  <el-button size="small" type="primary" v-if="!dataForm.id">上传票据</el-button>
						  <div slot="tip" class="el-upload__tip">支持上传PDF、图片等</div>
						</el-upload>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<template slot="footer">
			<el-button @click="visible = false">{{ $t('cancel') }}</el-button>
			<el-button type="primary" v-if="!dataForm.id" @click="dataFormSubmitHandle()" :loading="loadingbut">{{ $t('confirm') }}</el-button>
		</template>
	</el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      visible: false,
      url: `${window.SITE_CONFIG['apiURL']}/oss/file/upload2?access_token=${Cookies.get('access_token')}`,
      num: 0,
      dataForm: {
        id: '',
        code: '',
        number: '',
        amount: '',
        tax: '',
        total: '',
        billingDate: '',
        remark: '',
        attachment: ''
      },
      type: '',
      fileList: [],
      loadingbut: false
    }
  },
  computed: {
    dataRule () {
      var checkNum = (rule, value, callback) => {
        if (/^(?!0+(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/.test(value)) {
          callback()
        } else {
          callback(new Error('请输入数字值,并且最多两位小数'))
        }
      }
      return {
        code: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        number: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        amount: [{ required: true, message: '请输入数字值,并且最多两位小数', validator: checkNum, trigger: 'blur' }],
        tax: [{ required: true, message: '请输入数字值,并且最多两位小数', validator: checkNum, trigger: 'blur' }],
        total: [{ required: true, message: '请输入数字值,并且最多两位小数', validator: checkNum, trigger: 'blur' }],
        billingDate: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        attachment: [{ required: true, message: this.$t('validate.required'), trigger: 'blur' }]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.fileList = []
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    beforeUploadHandle (file) {
		  if (file.type != 'application/pdf' && file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/gif') {
		    this.$message.error(this.$t('upload.tip', { 'format': 'jpg、png、gif,pdf' }))
		    return false
		  }
		   if (file.size / 1024 / 1024 > 30) { this.$message.error('文件太大，只能上传30MB以内的文件'); return false }
		  this.num++
    },
    handleRemove (file, fileList) {
      this.dataForm.attachment = []
      for (let i = 0; i < fileList.length; i++) {
        fileList[i].name = fileList[i].response.data.fileName + '.' + fileList[i].response.data.fileType
        this.dataForm.attachment.push({ name: fileList[i].name, url: fileList[i].response.data.url })
      }
      this.fileList = fileList
    },
    // 上传成功
    successHandle (res, file, fileList) {
		  if (res.code !== 0) {
		    return this.$message.error(res.msg)
		  }
		  this.dataForm.attachment = []
		  for (let i = 0; i < fileList.length; i++) {
			  fileList[i].name = fileList[i].response.data.fileName + '.' + fileList[i].response.data.fileType;
        fileList[i].url = fileList[i].response.data.url;
			  this.dataForm.attachment.push({ name: fileList[i].name, url: fileList[i].response.data.url })
		  }
		  this.fileList = fileList
		  this.num--
    },

    backerror (e) {
      this.$message.error('文件上传失败，请重试')
    },
    handlePreview (file) {
      console.log(file)
			  if (!file.url) {
        this.$message.error('下载失败')
        return
			  }
			  const type = file.url.split('.')[4]
			  // 判断文件类型
			  if (type === 'doc' || type === 'docx' || type === 'xlsx' || type === 'xls' || type === 'ppt' || type === 'pptx') {
        // 在当前浏览器直接下载
        document.location.href = file.url
			  } else {
        // 图片在浏览器打开 新的页面展示
        window.open(file.url, file.name)
			  }
    },
    // 获取信息
    getInfo () {
      this.$http
        .get(`/sys/income-invoice/${this.dataForm.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data
          }
          this.fileList = []
          res.data.attachment = JSON.parse(res.data.attachment)
          if (res.data.attachment.length > 0) {
            let filelist = res.data.attachment
            for (let i = 0; i < filelist.length; i++) {
              let info = []
              info.status = 'success'
              info.url = filelist[i].url
              info.name = filelist[i].name
              console.log(info)
              this.fileList.push(info)
            }
          }
        })
        .catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        this.$refs['dataForm'].validate(valid => {
          if (!valid) {
            return false
          }
          this.loadingbut = true
          let url = ''
          if (this.dataForm.id > 0) {
            url = '/sys/income-invoice/update'
          } else {
            url = '/sys/income-invoice/create'
          }
          this.dataForm.attachment = JSON.stringify(this.dataForm.attachment)
          this.$http.post(url, this.dataForm, {
            headers: {
              'content-type': 'application/json;charset=UTF-8'
            }
          }).then(({ data: res }) => {
            this.loadingbut = false
            if (res.code !== 0) {
              return this.$message.error(res.msg)
            }
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.visible = false
                this.$emit('refreshDataList')
              }
            })
          })
            .catch(() => {})
        })
      },
      1000,
      { leading: true, trailing: false }
    )
  }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
</style>
